export const progressStats = {
  consecutiveDays: 42,
  totalHours: 386,
  completedNotes: 128,
  monthlyGoalProgress: 75,
  completedCourses: 23,
  ongoingCourses: 7,
};

export const learningPlan = {
  name: '2026 春季学习计划',
  startDate: '2026-01-01',
  endDate: '2026-06-30',
  phases: [
    {
      id: 1,
      name: '基础工具掌握',
      status: 'completed',
      progress: 100,
      startDate: '2026-01-01',
      endDate: '2026-02-15',
      goals: [
        'Photoshop 基础操作熟练',
        'Illustrator 矢量绘图入门',
        '完成 10 个练习项目',
      ],
    },
    {
      id: 2,
      name: '进阶技能提升',
      status: 'in-progress',
      progress: 65,
      startDate: '2026-02-16',
      endDate: '2026-04-30',
      goals: [
        '掌握高级修图技巧',
        'UI 设计规范学习',
        '视频剪辑基础',
        'AI 视觉生成实验',
      ],
    },
    {
      id: 3,
      name: '项目实战与作品集',
      status: 'pending',
      progress: 0,
      startDate: '2026-05-01',
      endDate: '2026-06-30',
      goals: [
        '完成 3 个完整项目',
        '整理个人作品集',
        '技术文章输出',
      ],
    },
  ],
};

export const courseCategories = [
  {
    id: 'design',
    name: '视觉设计',
    icon: 'ri-palette-line',
    color: 'from-pink-500 to-rose-500',
    bgColor: 'bg-pink-50',
    textColor: 'text-pink-600',
    totalCourses: 8,
    completedCourses: 6,
    totalHours: 96,
    learnedHours: 78,
    courses: [
      { name: 'Photoshop 高级修图', progress: 100, status: 'completed', hours: 18 },
      { name: 'Illustrator 矢量插画', progress: 100, status: 'completed', hours: 14 },
      { name: 'UI 设计规范与组件库', progress: 80, status: 'in-progress', hours: 20 },
      { name: '品牌视觉设计系统', progress: 60, status: 'in-progress', hours: 16 },
      { name: '排版与字体设计', progress: 100, status: 'completed', hours: 10 },
      { name: '色彩理论与应用', progress: 100, status: 'completed', hours: 8 },
      { name: '动效设计基础', progress: 30, status: 'in-progress', hours: 12 },
      { name: '印刷与包装设计', progress: 0, status: 'pending', hours: 10 },
    ],
  },
  {
    id: 'ai',
    name: 'AI 创作',
    icon: 'ri-robot-line',
    color: 'from-violet-500 to-purple-500',
    bgColor: 'bg-violet-50',
    textColor: 'text-violet-600',
    totalCourses: 5,
    completedCourses: 2,
    totalHours: 60,
    learnedHours: 28,
    courses: [
      { name: 'Stable Diffusion 入门', progress: 100, status: 'completed', hours: 12 },
      { name: 'Midjourney 高级提示词', progress: 100, status: 'completed', hours: 10 },
      { name: 'ComfyUI 工作流搭建', progress: 55, status: 'in-progress', hours: 14 },
      { name: 'ControlNet 精准控图', progress: 20, status: 'in-progress', hours: 12 },
      { name: 'AI 视频生成实战', progress: 0, status: 'pending', hours: 14 },
    ],
  },
  {
    id: 'video',
    name: '视频剪辑',
    icon: 'ri-movie-2-line',
    color: 'from-red-500 to-orange-500',
    bgColor: 'bg-red-50',
    textColor: 'text-red-600',
    totalCourses: 4,
    completedCourses: 2,
    totalHours: 48,
    learnedHours: 30,
    courses: [
      { name: 'Premiere Pro 基础剪辑', progress: 100, status: 'completed', hours: 12 },
      { name: '转场与特效技巧', progress: 100, status: 'completed', hours: 8 },
      { name: 'After Effects 动效', progress: 45, status: 'in-progress', hours: 16 },
      { name: '调色与 LUT 应用', progress: 15, status: 'in-progress', hours: 10 },
    ],
  },
  {
    id: 'photography',
    name: '摄影后期',
    icon: 'ri-camera-3-line',
    color: 'from-amber-500 to-yellow-500',
    bgColor: 'bg-amber-50',
    textColor: 'text-amber-600',
    totalCourses: 4,
    completedCourses: 3,
    totalHours: 40,
    learnedHours: 34,
    courses: [
      { name: 'Lightroom 基础调色', progress: 100, status: 'completed', hours: 10 },
      { name: '人像精修技法', progress: 100, status: 'completed', hours: 12 },
      { name: '风光后期处理', progress: 100, status: 'completed', hours: 8 },
      { name: '商业产品摄影后期', progress: 40, status: 'in-progress', hours: 10 },
    ],
  },
  {
    id: 'writing',
    name: '内容创作',
    icon: 'ri-quill-pen-line',
    color: 'from-teal-500 to-emerald-500',
    bgColor: 'bg-teal-50',
    textColor: 'text-teal-600',
    totalCourses: 3,
    completedCourses: 2,
    totalHours: 30,
    learnedHours: 22,
    courses: [
      { name: '技术写作与文档规范', progress: 100, status: 'completed', hours: 8 },
      { name: '新媒体内容策划', progress: 100, status: 'completed', hours: 10 },
      { name: '个人品牌内容运营', progress: 40, status: 'in-progress', hours: 12 },
    ],
  },
  {
    id: 'frontend',
    name: '前端开发',
    icon: 'ri-code-s-slash-line',
    color: 'from-sky-500 to-cyan-500',
    bgColor: 'bg-sky-50',
    textColor: 'text-sky-600',
    totalCourses: 4,
    completedCourses: 1,
    totalHours: 56,
    learnedHours: 18,
    courses: [
      { name: 'HTML & CSS 基础', progress: 100, status: 'completed', hours: 10 },
      { name: 'JavaScript 入门', progress: 50, status: 'in-progress', hours: 16 },
      { name: 'React 组件开发', progress: 20, status: 'in-progress', hours: 18 },
      { name: 'Tailwind CSS 实战', progress: 0, status: 'pending', hours: 12 },
    ],
  },
];

export const skillProgress = [
  {
    name: 'Photoshop',
    level: '进阶',
    progress: 85,
    color: 'from-pink-500 to-rose-400',
    icon: 'ri-image-edit-line',
  },
  {
    name: 'Illustrator',
    level: '中级',
    progress: 70,
    color: 'from-orange-500 to-amber-500',
    icon: 'ri-pen-nib-line',
  },
  {
    name: 'AI 视觉生成',
    level: '中级',
    progress: 62,
    color: 'from-violet-500 to-purple-500',
    icon: 'ri-robot-line',
  },
  {
    name: '视频剪辑',
    level: '初级',
    progress: 48,
    color: 'from-red-500 to-orange-500',
    icon: 'ri-movie-2-line',
  },
  {
    name: 'UI 设计',
    level: '中级',
    progress: 65,
    color: 'from-teal-500 to-emerald-500',
    icon: 'ri-layout-line',
  },
  {
    name: 'Lightroom',
    level: '进阶',
    progress: 80,
    color: 'from-amber-500 to-yellow-400',
    icon: 'ri-camera-3-line',
  },
  {
    name: 'After Effects',
    level: '入门',
    progress: 35,
    color: 'from-sky-500 to-cyan-500',
    icon: 'ri-film-line',
  },
  {
    name: '内容写作',
    level: '中级',
    progress: 72,
    color: 'from-green-500 to-emerald-500',
    icon: 'ri-quill-pen-line',
  },
];

export const monthlyGoals = [
  {
    month: '2026年3月',
    goals: [
      { id: 1, text: '完成 Photoshop 光影关系专题学习', completed: true },
      { id: 2, text: '输出 5 篇技术分享文章', completed: true },
      { id: 3, text: '完成 3 个海报设计练习', completed: true },
      { id: 4, text: '学习 Stable Diffusion 本地部署', completed: false },
      { id: 5, text: '掌握视频转场技巧', completed: false },
      { id: 6, text: '完成 ComfyUI 工作流搭建课程', completed: false },
    ],
  },
  {
    month: '2026年2月',
    goals: [
      { id: 1, text: '完成 Illustrator 基础课程', completed: true },
      { id: 2, text: '输出 4 篇学习笔记', completed: true },
      { id: 3, text: '完成 UI 设计规范学习', completed: true },
      { id: 4, text: '参与 1 个实战项目', completed: true },
      { id: 5, text: '完成 Lightroom 人像精修课程', completed: true },
    ],
  },
  {
    month: '2026年1月',
    goals: [
      { id: 1, text: '制定全年学习计划', completed: true },
      { id: 2, text: '完成 Photoshop 基础课程', completed: true },
      { id: 3, text: '搭建个人学习博客', completed: true },
      { id: 4, text: '输出 3 篇学习总结', completed: true },
    ],
  },
];

export const recentLearningRecords = [
  {
    date: '2026-03-15',
    dayOfWeek: '周六',
    duration: '4.5小时',
    records: [
      {
        time: '09:00 - 11:30',
        title: 'Photoshop 光影关系深度学习',
        category: '视觉设计',
        description: '学习了高光、中间调、阴影的分离调整技巧，完成了 3 张人像光影重塑练习。',
      },
      {
        time: '14:00 - 16:00',
        title: 'AI 视觉生成实验',
        category: 'AI 创作',
        description: '测试了 Stable Diffusion 不同采样器的效果差异，记录了最佳参数组合。',
      },
    ],
  },
  {
    date: '2026-03-14',
    dayOfWeek: '周五',
    duration: '3小时',
    records: [
      {
        time: '19:00 - 22:00',
        title: 'UI 设计规范整理',
        category: 'UI 设计',
        description: '整理了移动端设计规范文档，包括间距、字号、颜色系统等内容。',
      },
    ],
  },
  {
    date: '2026-03-13',
    dayOfWeek: '周四',
    duration: '2.5小时',
    records: [
      {
        time: '20:00 - 22:30',
        title: '视频剪辑转场技巧学习',
        category: '视频剪辑',
        description: '学习了 Premiere Pro 中 10 种常用转场效果，完成了 1 个短视频练习。',
      },
    ],
  },
  {
    date: '2026-03-12',
    dayOfWeek: '周三',
    duration: '4小时',
    records: [
      {
        time: '09:00 - 11:00',
        title: 'Illustrator 矢量插画练习',
        category: '视觉设计',
        description: '完成了 2 个扁平风格插画，练习了钢笔工具和形状生成器的使用。',
      },
      {
        time: '15:00 - 17:00',
        title: '技术文章写作',
        category: '内容创作',
        description: '撰写了《字体排版的 5 个核心原则》技术分享文章，获得不少读者反馈。',
      },
    ],
  },
  {
    date: '2026-03-11',
    dayOfWeek: '周二',
    duration: '3.5小时',
    records: [
      {
        time: '19:30 - 23:00',
        title: 'Photoshop 图像精修实战',
        category: '摄影后期',
        description: '完成了 1 张商业产品图精修，练习了高低频磨皮和色彩分离技巧。',
      },
    ],
  },
  {
    date: '2026-03-10',
    dayOfWeek: '周一',
    duration: '2小时',
    records: [
      {
        time: '20:00 - 22:00',
        title: 'ComfyUI 工作流搭建',
        category: 'AI 创作',
        description: '搭建了基础的文生图工作流，学习了节点连接和参数调整方法。',
      },
    ],
  },
  {
    date: '2026-03-09',
    dayOfWeek: '周日',
    duration: '5小时',
    records: [
      {
        time: '10:00 - 12:30',
        title: 'After Effects 动效基础',
        category: '视频剪辑',
        description: '学习了关键帧动画、缓动曲线和图层混合模式，完成了 2 个 UI 动效练习。',
      },
      {
        time: '14:00 - 16:30',
        title: 'Lightroom 商业产品调色',
        category: '摄影后期',
        description: '学习了产品摄影的白平衡校正、高光压制和阴影提亮技巧，处理了 20 张产品图。',
      },
    ],
  },
];

export const progressData = {
  overallProgress: 75,
  courseCategories: courseCategories.map((cat, index) => ({
    id: index + 1,
    name: cat.name,
    icon: cat.icon,
    hours: cat.learnedHours,
    courses: cat.completedCourses,
    color: cat.color,
    courses_list: cat.courses.map(c => ({
      name: c.name,
      progress: c.progress,
    })),
  })),
  skillDirections: skillProgress.map(s => ({
    name: s.name,
    level: s.progress,
    color: s.color,
  })),
  learningRecords: recentLearningRecords.flatMap(day =>
    day.records.map(r => ({
      date: day.date,
      content: r.title,
      duration: day.duration,
      category: r.category,
    }))
  ),
  monthlyGoals: monthlyGoals.map(m => ({
    month: m.month,
    target: m.goals.length,
    completed: m.goals.filter(g => g.completed).length,
  })),
};
